import { Component, HostListener, ElementRef } from '@angular/core';
import { trigger, state, style, animate, transition, animateChild } from '@angular/animations';

@Component({
  selector: 'working-with',
  templateUrl: './working-with.component.html',
  styleUrls: ['./working-with.component.sass'],
  animations: [    
    trigger('scrollAnimation-amtrust', [
      state('hide', style({ opacity: 0 })),
      state('show', style({ opacity: 1 })),

      transition('hide => show', animate('1s 2s ease-in')),
     // transition('show => hide', animate(350))      
    ]),    
    trigger('scrollAnimation-bigprop', [
      state('show', style({ opacity: 1 })),
      state('hide', style({ opacity: 0 })),
     // transition('show => hide', animate(450)),
      transition('hide => show', animate('1s 1400ms ease-in'))
    ]),
    trigger('scrollAnimation-ea', [
      state('show', style({ opacity: 1 })),
      state('hide', style({ opacity: 0 })),
     // transition('show => hide', animate(900)),
      transition('hide => show', animate('1s 1000ms ease-in'))
    ]),
    trigger('scrollAnimation-ergo', [
      state('show', style({ opacity: 1 })),
      state('hide', style({ opacity: 0 })),
     // transition('show => hide', animate(650)),
      transition('hide => show', animate('1s 650ms ease-in'))
    ]),
    trigger('scrollAnimation-jba', [
      state('show', style({ opacity: 1 })),
      state('hide', style({ opacity: 0 })),
    //  transition('show => hide', animate('800ms ease-out')),
      transition('hide => show', animate('1s 700ms ease-in'))
    ]),
    trigger('scrollAnimation-landreg', [
      state('show', style({ opacity: 1 })),
      state('hide', style({ opacity: 0 })),
     // transition('show => hide', animate('800ms ease-out')),
      transition('hide => show', animate('1s 1400ms ease-in'))
    ]),
    trigger('scrollAnimation-lloyds', [
      state('show', style({ opacity: 1 })),
      state('hide', style({ opacity: 0 })),
     // transition('show => hide', animate('800ms ease-out')),
      transition('hide => show', animate('1s 900ms ease-in'))
    ]),
    trigger('scrollAnimation-nation', [
      state('show', style({ opacity: 1 })),
      state('hide', style({ opacity: 0 })),
    //  transition('show => hide', animate('800ms ease-out')),
      transition('hide => show', animate('1s 400ms ease-in'))
    ]),
    trigger('scrollAnimation-os', [
      state('show', style({ opacity: 1 })),
      state('hide', style({ opacity: 0 })),
    //  transition('show => hide', animate('800ms ease-out')),
      transition('hide => show', animate('1s 1700ms ease-in'))
    ]),
    trigger('scrollAnimation-propassure', [
      state('show', style({ opacity: 1 })),
      state('hide', style({ opacity: 0 })),
    //  transition('show => hide', animate('800ms ease-out')),
      transition('hide => show', animate('1s 950ms ease-in'))
    ]),
    trigger('scrollAnimation-proprisk', [
      state('show', style({ opacity: 1 })),
      state('hide', style({ opacity: 0 })),
    //  transition('show => hide', animate('800ms ease-out')),
      transition('hide => show', animate('1s 1900ms ease-in'))
    ]),
    trigger('scrollAnimation-rsa', [
      state('show', style({ opacity: 1 })),
      state('hide', style({ opacity: 0 })),
    //  transition('show => hide', animate('800ms ease-out')),
      transition('hide => show', animate('1s 750ms ease-in'))
    ]),
    trigger('scrollAnimation-when', [
      state('show', style({ opacity: 1 })),
      state('hide', style({ opacity: 0 })),
    //  transition('show => hide', animate('800ms ease-out')),
      transition('hide => show', animate('1s 650ms ease-in'))
    ]),
    trigger('scrollAnimation-dclg', [
      state('show', style({ opacity: 1 })),
      state('hide', style({ opacity: 0 })),    
    //  transition('show => hide', animate('800ms ease-out')),
      transition('hide => show', animate('1s 1250ms ease-in'))
    ]),
    trigger('scrollAnimation-earthSense', [
      state('show', style({ opacity: 1 })),
      state('hide', style({ opacity: 0 })),    
    //  transition('show => hide', animate('800ms ease-out')),
      transition('hide => show', animate('1s 550ms ease-in'))
    ]),
    trigger('scrollAnimation-shawbrook', [
      state('show', style({ opacity: 1 })),
      state('hide', style({ opacity: 0 })),    
    //  transition('show => hide', animate('800ms ease-out')),
      transition('hide => show', animate('1s 1600ms ease-in'))
    ]),
    trigger('scrollAnimation-rbs', [
      state('show', style({ opacity: 1 })),
      state('hide', style({ opacity: 0 })),    
    //  transition('show => hide', animate('800ms ease-out')),
      transition('hide => show', animate('1s 1100ms ease-in'))
    ]),
    trigger('scrollAnimation-sdl', [
      state('show', style({ opacity: 1 })),
      state('hide', style({ opacity: 0 })),    
    //  transition('show => hide', animate('800ms ease-out')),
      transition('hide => show', animate('1s 500ms ease-in'))
    ])
  ]
})
export class WorkingWithComponent {

  state = 'hide'

  constructor(public el: ElementRef) {
  }

  @HostListener('window:scroll', ['$event']) fadeOnScroll() {
    let componentPosition = this.el.nativeElement.offsetParent.offsetTop - 700
    let scrollPosition = window.pageYOffset
    
    if (scrollPosition >= componentPosition) {
      this.state = 'show';
    } 
  }
  
  public randomIntFromInterval(min, max): number {
    return Math.floor(Math.random() * (max - min + 1) + min);
  } 
}

class Logo {
  id: string;
  src: string;
  width: number;

  constructor(_id: string, _src: string, _width: number) {
    this.id = _id;
    this.src = _src;
    this.width = _width;
  }
}
